import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {catchError, map, Observable, throwError} from 'rxjs';
import { DataServiceGraph, keyStringData } from 'src/app/models/data-service-graph';
import { CSVQueryModel } from "../../models/csv-query-model";

@Injectable()
export class ReportService {

  readonly statusApi = '/api/reporting/solicitud/negos';

  constructor(public http: HttpClient) { }

  downloadCsvFile(csvQueryModel: CSVQueryModel, subPath: string = ""): Observable<any> {
    const url = this.statusApi + `/export-csv${subPath}?dateFrom=${csvQueryModel.dateFrom ? csvQueryModel.dateFrom:''}&dateTo=${csvQueryModel.dateTo ? csvQueryModel.dateTo:''}&processDateFrom=${csvQueryModel.processDateFrom ? csvQueryModel.processDateFrom:''}&processDateTo=${csvQueryModel.processDateTo ? csvQueryModel.processDateTo:''}&status=${csvQueryModel.status ? csvQueryModel.status:''}&pnr=${csvQueryModel.pnr ? csvQueryModel.pnr:''}&applicantUser=${csvQueryModel.applicationUser ? csvQueryModel.applicationUser:''}&profile=${csvQueryModel.profile}&user=${csvQueryModel.user}&cuenta=${csvQueryModel.cuenta}`;
    return this.http.get(url, { responseType: 'text' as 'text' }).pipe(
      map((response)=>{
        return {
          filename: 'negos_export_' + new Date().toISOString().substring(0,19).replace(':','-') + '.csv',
          data: response
        };
      }),
      catchError(e => {
        console.error("Error en export-csv", e);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  getInfoCardsDashboard(email: string){
    const url = this.statusApi + `/accumulated?user=${email}`;
    return this.http.get<keyStringData>(url).pipe(
      catchError(e => {
        console.error(e.error.message);
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  getGraphNegos(email: string){
    const url = this.statusApi + `/months?user=${email}`;
    return this.http.get<DataServiceGraph>(url).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }

  getCsvNegos(email: string){
    const url = this.statusApi + `/months?user=${email}`;
    return this.http.get<DataServiceGraph>(url).pipe(
      catchError(e => {
        return throwError(() => new Error(e.error.message));
      })
    );
  }

}

